export default "Writing\nJerry Jäppinen\n\nGame developer\nJerry Jäppinen\n\nMusic\nBensounds";